import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={46}
            height={47}
            viewBox="0 0 46 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            >
            <rect x={0.5} y={0.898438} width={45} height={45} rx={22.5} fill="#fff" />
            <rect
                x={0.5}
                y={0.898438}
                width={45}
                height={45}
                rx={22.5}
                stroke={theme["#0EA59D"]}
            />
            <path
                d="M28.751 25.924a3.332 3.332 0 00-3.333 3.333 3.332 3.332 0 106.667 0 3.332 3.332 0 00-3.334-3.333zm1.334 4.708a.618.618 0 01-.442.183.618.618 0 01-.442-.183l-.441-.442-.459.459a.618.618 0 01-.441.183.618.618 0 01-.442-.183.629.629 0 010-.884l.458-.458-.441-.441a.629.629 0 010-.884.629.629 0 01.883 0l.442.442.416-.417a.629.629 0 01.884 0 .629.629 0 010 .883l-.417.417.442.442a.629.629 0 010 .883zM31.333 19.689v.375a.836.836 0 01-.834.833h-15a.836.836 0 01-.833-.833v-.384a3.446 3.446 0 013.45-3.45h9.758a3.46 3.46 0 013.459 3.459z"
                fill={theme["#0D968F"]}
            />
            <path
                d="M14.666 22.98v4.134a3.446 3.446 0 003.45 3.45h5.217c.483 0 .9-.409.858-.892-.117-1.275.292-2.658 1.425-3.758a4.231 4.231 0 011.667-1.009 4.664 4.664 0 012.941.009.834.834 0 001.109-.784v-1.158a.836.836 0 00-.834-.833h-15a.848.848 0 00-.833.841zm5 4.792h-1.667a.63.63 0 01-.625-.625.63.63 0 01.625-.625h1.667a.63.63 0 01.625.625.63.63 0 01-.625.625z"
                fill={theme["#0D968F"]}
            />
        </svg>
      )
}
  
  export default SvgComponent